// styling
import styles from './styles.module.scss';

// components
import Spring from '@components/Spring';

// hooks
import { useThemeProvider } from '@contexts/themeContext';

// utils
import PropTypes from 'prop-types';
import { SERVICE_URL } from '../../config';

// Tarjeta de un documento (PDF): abre el archivo en otra pestaña. `file` es relativo al backend.
// El detalle solo se muestra si aporta algo distinto al nombre.
const DocumentCard = ({ name, detail, file, index }) => {
    const { theme } = useThemeProvider();

    return (
        <a
            className={styles.link}
            href={SERVICE_URL + file}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Abrir ${name}`}
        >
            <Spring className={`${styles.card} ${styles[theme]}`} type="slideUp" index={index}>
                <span className={styles.icon}>
                    <i className="icon icon-pdf" />
                </span>
                <span className={styles.text}>
                    <span className={styles.name}>{name}</span>
                    {detail && detail !== name && <span className={styles.detail}>{detail}</span>}
                </span>
                <span className={styles.open}>
                    <i className="icon icon-chevron-right" />
                </span>
            </Spring>
        </a>
    );
};

DocumentCard.propTypes = {
    name: PropTypes.string.isRequired,
    detail: PropTypes.string,
    file: PropTypes.string.isRequired,
    index: PropTypes.number,
};

export default DocumentCard;
